import { render, staticRenderFns } from "./table-view.vue?vue&type=template&id=16fd8f86&"
import script from "./table-view.vue?vue&type=script&lang=ts&"
export * from "./table-view.vue?vue&type=script&lang=ts&"
import style0 from "./table-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports